import ChangePassword from "@/pages/auth/change-password";
import ForgotPassword from "@/pages/auth/forgot-password";
import ResetPassword from "@/pages/auth/reset-password";
import Login from "@/pages/auth/login.vue";

export default [
    {
        path: "/auth/forgot-password",
        name: "auth-forgot-password",
        displayName: "routes.zaboravljena-lozinka",
        icon: "mdi-lock-question",
        component: ForgotPassword,
        roles: [],
    },
    {
        path: "/auth/reset-password",
        name: "auth-reset-password",
        displayName: "routes.resetovanje-lozinke",
        icon: "mdi-lock-reset",
        component: ResetPassword,
        roles: [],
    },
    {
        path: "/auth/change-password",
        name: "auth-change-password",
        displayName: "routes.promjena-lozinke",
        icon: "mdi-lock",
        component: ChangePassword,
        roles: [],
    },
    {
        path: "/auth/login",
        name: "auth-login",
        displayName: "routes.logovanje",
        icon: "mdi-login",
        component: Login,
        roles: [],
    },
]